/** Administrative exemption. Distinct from a verified document approval. */
export interface OnboardingRequirementView {
  requirementKey?: string;
  administrativeDecision?: string | null;
  reviewStatus?: string | null;
  currentStatus?: string | null;
}

const NON_WAIVABLE = new Set(['TERMS_AGREEMENT']);

export function isWaivedRequirement(group: OnboardingRequirementView): boolean {
  return (group.administrativeDecision || '').toUpperCase() === 'WAIVED';
}

export function requirementSatisfiesApprovalGate(group: OnboardingRequirementView): boolean {
  if (isWaivedRequirement(group)) {
    return true;
  }
  if (group.requirementKey === 'TERMS_AGREEMENT') {
    return group.currentStatus === 'SUBMITTED' || group.currentStatus === 'APPROVED';
  }
  return group.reviewStatus === 'Aprobado';
}

/** Applicant-submitted date of birth. A missing or underage value is not eligible. */
export function ageEligibilityEstablished(review: {
  dateOfBirth?: string | null;
  age?: number | null;
} | null | undefined): boolean {
  if (!review?.dateOfBirth) {
    return false;
  }
  return typeof review.age === 'number' && review.age >= 18;
}

export function canWaiveRequirement(group: OnboardingRequirementView): boolean {
  if (!group.requirementKey || NON_WAIVABLE.has(group.requirementKey)) {
    return false;
  }
  if (isWaivedRequirement(group)) {
    return false;
  }
  return !requirementSatisfiesApprovalGate(group);
}
